import { createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 23.06 19.09"
}
const _hoisted_2 = { id: "defs4" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<circle id=\"circle6\" cx=\"4.93\" cy=\"16.23\" r=\"1.91\" class=\"cls-1\"></circle><circle id=\"circle8\" cx=\"18.29\" cy=\"16.23\" r=\"1.91\" class=\"cls-1\"></circle><path id=\"polyline10\" d=\"M20.59 18.68h1.91v-5.72l-1.91-5.73h-3.82v11.45\" class=\"cls-1\" transform=\"translate(-.39 -2.46)\"></path><path id=\"line12\" d=\"M19.25 11.46h2.86\" class=\"cls-1\"></path><path id=\"polyline14\" d=\"M7.23 18.68h9.54v-4.77H1.5v4.77h1.91\" class=\"cls-1\" transform=\"translate(-.39 -2.46)\"></path><path id=\"path16\" d=\"M9.7 11.46H6.84L1.11 7.63 3.02.96H9.7a3.82 3.82 0 0 1 3.82 3.83v2.85a3.82 3.82 0 0 1-3.82 3.82\" class=\"cls-1\"></path><path id=\"line18\" d=\"m7.79.96-2.86 9.53\" class=\"cls-1\"></path><path id=\"line20\" d=\"m11.61 1.91-2.86 9.55\" class=\"cls-1\"></path>", 8)

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("defs", _hoisted_2, [
      (_openBlock(), _createBlock(_resolveDynamicComponent("style"), { id: "style2" }, {
        default: _withCtx(() => [
          _createTextVNode(".cls-1{fill:none;stroke-miterlimit:10;stroke-width:1.91px}")
        ]),
        _: 1
      }))
    ]),
    _hoisted_3
  ]))
}
export default { render: render }